export enum ApiFeatureType {
  core_company_calendar = "core_company_calendar",
  time_off = "time_off",
  approvals = "approvals",

  ats = "ats",
  ats_ai = "ats_ai",
  ats_gdpr = "ats_gdpr",
  ats_hiring_plan = "ats_hiring_plan",
  blog = "blog",
  talent_surveys = "talent_surveys",
  ats_scorecards = "ats_scorecards",
  talent_performance_reviews = "talent_performance_reviews",
  workflows = "workflows",

  talent_surveys_ai = "talent_surveys_ai",
  talent_performance_reviews_ai = "talent_performance_reviews_ai",
  ai_assistant = "ai_assistant",
  ats_career_site = "ats_career_site",
  custom_fields = "custom_fields",
  goals = "goals",
  tasks = "tasks",
  clocking = "clocking",
  esign = "esign",
  recognitions = "recognitions",
}

export interface ApiPlanFeature {
  enabled: boolean;
  available: boolean;
}

export enum ApiPlanStatus {
  active = "active",
  trial = "trial",
  inactive = "inactive",
  system = "system",
}

export interface ApiPlanFeatures {
  [ApiFeatureType.time_off]: ApiPlanFeature;
  [ApiFeatureType.approvals]: ApiPlanFeature;
  [ApiFeatureType.ats]: ApiPlanFeature;
  [ApiFeatureType.ats_gdpr]: ApiPlanFeature;
  [ApiFeatureType.ats_hiring_plan]: ApiPlanFeature;
  [ApiFeatureType.ats_ai]: ApiPlanFeature;
  [ApiFeatureType.core_company_calendar]: ApiPlanFeature;
  [ApiFeatureType.blog]: ApiPlanFeature;
  [ApiFeatureType.talent_surveys]: ApiPlanFeature;
  [ApiFeatureType.talent_surveys_ai]: ApiPlanFeature;
  [ApiFeatureType.talent_performance_reviews_ai]: ApiPlanFeature;
  [ApiFeatureType.ai_assistant]: ApiPlanFeature;
  [ApiFeatureType.ats_scorecards]: ApiPlanFeature;
  [ApiFeatureType.talent_performance_reviews]: ApiPlanFeature;
  [ApiFeatureType.ats_career_site]: ApiPlanFeature;
  [ApiFeatureType.custom_fields]: ApiPlanFeature;
  [ApiFeatureType.workflows]: ApiPlanFeature;
  [ApiFeatureType.goals]: ApiPlanFeature;
  [ApiFeatureType.tasks]: ApiPlanFeature;
  [ApiFeatureType.clocking]: ApiPlanFeature;
  [ApiFeatureType.esign]: ApiPlanFeature;
  [ApiFeatureType.recognitions]: ApiPlanFeature;
}

export interface ApiPlan {
  features: ApiPlanFeatures;
  status: ApiPlanStatus;
  record_session: boolean;
}

export type ApiFeatureSettingsPayload = {
  features: {
    [key in ApiFeatureType]?: {
      enabled: boolean;
    };
  };
};
